import React from "react";
import "../Styles/Hero.css";
import logo from "../assets/Main Logo.jpg";
import heroVisual from "../assets/Boy studying remotely with tutor.svg";

const Hero = ({ scrollToSection }) => {
  return (
    <section className="hero" aria-label="True Bloom Tutoring">
      <div className="hero-blob one" aria-hidden="true"></div>
      <div className="hero-blob two" aria-hidden="true"></div>

      <div className="hero-inner">
        <div className="hero-copy">
          <img className="hero-brand" src={logo} alt="True Bloom Tutoring" />
          <p className="eyebrow">For Calgary &amp; Airdrie parents</p>
          <h1>
            Your child isn’t “bad at math.”
            <span className="accent"> They just need the right person.</span>
          </h1>
          <p>
            Personalized one-on-one tutoring that rebuilds confidence, ends homework
            battles, and helps your teen finally understand the material.
          </p>
          <div className="hero-actions">
            <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
              Book a Free Intro Call
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection("results")}>
              See Parent Results
            </button>
          </div>
          <div className="hero-reassure">
            <span>No pressure consult</span>
            <span>Matched university tutors</span>
            <span>Alberta curriculum</span>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-visual-frame">
            <img
              src={heroVisual}
              alt="Student receiving one-on-one tutoring support"
            />
          </div>
        </div>
      </div>

      <svg className="hero-wave" viewBox="0 0 1440 72" preserveAspectRatio="none" aria-hidden="true">
        <path
          fill="currentColor"
          d="M0,40 C240,70 480,10 720,34 C960,58 1200,70 1440,28 L1440,72 L0,72 Z"
        />
      </svg>
    </section>
  );
};

export default Hero;
